<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fa fa-street-view" id="ico"></i>
		<h1 style="display: inline-block;">Vista Street View</h1>
	</div>
</div>
<mat-divider></mat-divider>
<div class="kt-portlet">
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div mat-dialog-content style="overflow: hidden;">
						<div [hidden]="!isAvailable" id="pano" style="width: 100%; height: 320px;"></div>
						<div *ngIf="!isAvailable">No se encuentra disponible la función street view en esta zona</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
